import { createDialogHook } from '../common-hooks';
import { DocumentCompletionDialogComponent } from '../../../domains/dialogs/document-completion-dialog/document-completion-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmUseExtractedDataForTrainingDialogComponent } from '../../../domains/dialogs/confirm-use-extracted-data-for-training-dialog.component';
import { map, of, switchMap } from 'rxjs';
import { DivergingSuggestedSumDialogComponent } from '../../../domains/dialogs/diverging-suggested-sum-dialog.component';
import { mapValues } from '@ps-gui/shared-utils';
import { ExtractedDataStoreService } from '../../extracted-data/extracted-data-store.service';

const extractionOverviewDialogHook = createDialogHook<{
  accept: boolean;
  useExtractedDataForTraining?: boolean;
}>(DocumentCompletionDialogComponent);

export const showDivergingSumDialogHook = (dialogService: DialogService) =>
  createDialogHook<boolean>(DivergingSuggestedSumDialogComponent)(dialogService).pipe(
    map((result) => !!result),
  );

export const showDocumentExtractionSummaryHook = (
  documentId: string,
  documentClass: string,
  dialogService: DialogService,
  extractedDataStoreService: ExtractedDataStoreService,
) =>
  of(extractedDataStoreService.getExtractedDocumentDataSnapshot(documentId)).pipe(
    switchMap((extractedDocumentData) =>
      extractionOverviewDialogHook(dialogService, {
        documentId,
        documentClass,
        extractedRowCountByTableKey: mapValues(
          extractedDocumentData.tables,
          (_, table) => table.length,
        ),
        extractedBatchFields: extractedDocumentData.fields,
      }),
    ),
    map((result) => result ?? { accept: false }),
  );

export const useExtractedDataForTrainingConfirmationHook = (dialogService: DialogService) =>
  createDialogHook<boolean>(ConfirmUseExtractedDataForTrainingDialogComponent)(dialogService).pipe(
    map((result) => !!result),
  );
